import { Component, EventEmitter, Input, Output } from "@angular/core";

import { IEidosFiltersRegistry } from "@common/models/eidos-filters.models";
import { EidosFilterComponent } from "@common/components/entities/filters/eidos-filter/eidos-filter.component";

@Component({
  selector: 'eidos-filter-slider',
  templateUrl: './eidos-filter-slider.component.html',
  styleUrls: ['./eidos-filter-slider.component.scss']
})
export class EidosFilterSliderComponent extends EidosFilterComponent {
  /**
   * Current filter value (2-way binding)
   *
   * @type {IEidosFiltersRegistry["slider"]["valueType"]}
   * @memberof EidosFilterSliderComponent
   */
  protected _value: IEidosFiltersRegistry["slider"]["valueType"];
  @Input() public get value(): IEidosFiltersRegistry["slider"]["valueType"] {
    return this._value;
  }
  public set value(val: IEidosFiltersRegistry["slider"]["valueType"]) {
    this._value = val;
    this.valueChange.emit(this._value);
  }
  @Output() public valueChange: EventEmitter<IEidosFiltersRegistry["slider"]["valueType"]> = new EventEmitter<IEidosFiltersRegistry["slider"]["valueType"]>();
  /**
   * Current second filter (for range) value (2-way binding)
   *
   * @type {*}
   * @memberof EidosFilterSliderComponent
   */
  protected _otherValue: IEidosFiltersRegistry["slider"]["valueType"];
  @Input() public get otherValue(): IEidosFiltersRegistry["slider"]["valueType"] {
    return this._otherValue;
  }
  public set otherValue(val: IEidosFiltersRegistry["slider"]["valueType"]) {
    this._otherValue = val;
    this.otherValueChange.emit(this._otherValue);
  }
  @Output() public otherValueChange: EventEmitter<IEidosFiltersRegistry["slider"]["valueType"]> = new EventEmitter<IEidosFiltersRegistry["slider"]["valueType"]>();
  /**
   * Filter configuration
   *
   * @type {IEidosFiltersRegistry["slider"]["config"]}
   * @memberof EidosFilterSliderComponent
   */
  @Input() public config: IEidosFiltersRegistry["slider"]["config"];

  constructor() {
    super();
  }
}
